import { createAutocomplete } from '@algolia/autocomplete-core';
import AlgoliaSearch from 'algoliasearch/lite';
import { useCallback, useMemo, useState } from 'react';
import { debounceAutoComplete } from './DebouceAutocomplete';

// source: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/state
export const AutoCompleteStatusValues = {
  IDLE: 'idle',
  LOADING: 'loading',
  STALLED: 'stalled',
  ERROR: 'error'
};

// TODO: Replace with value from bootstrap config
const searchClient = AlgoliaSearch('7LVR1JKTDF', '3ef48f0fc67ee7e9c5a9dbbf6b45908c');

/* We use parseAlgoliaHitHighlight() from @algolia/autocomplete-preset-algolia
  There's a limitation of this function, that it only parses the highlight for following
  highlightPreTag and highlightPostTag. Hence we are passing same as arguments when fetching search results.
*/
const HIGHLIGHT_PRE_TAG = '__aa-highlight__';
const HIGHLIGHT_POST_TAG = '__/aa-highlight__';
const useAlgoliaAutocomplete = (inputRef, placeholder, initQuery) => {
  const [autocompleteState, setAutocompleteState] = useState({
    collections: [],
    completion: null,
    context: {},
    isOpen: false,
    query: '',
    activeItemId: null,
    status: 'idle'
  });
  const debouncedGetSources = useCallback(_ref => {
    let {
      query
    } = _ref;
    if (!query) {
      return [];
    }
    return debounceAutoComplete([{
      sourceId: 'querySuggestions',
      getItems() {
        return searchClient.search([{
          indexName: 'marketplace_plugins_prod_query_suggestions',
          query,
          params: {
            hitsPerPage: 6,
            snippetEllipsisText: '…',
            highlightPreTag: HIGHLIGHT_PRE_TAG,
            highlightPostTag: HIGHLIGHT_POST_TAG
          }
        }]).then(_ref2 => {
          let {
            results
          } = _ref2;
          const firstResult = results[0];
          const {
            hits
          } = firstResult;
          return hits;
        });
      },
      getItemUrl(_ref3) {
        let {
          item
        } = _ref3;
        return item.url;
      }
    }]);
  }, []);
  const autocomplete = useMemo(() => createAutocomplete({
    id: 'search',
    placeholder,
    openOnFocus: true,
    onStateChange(props) {
      setAutocompleteState(props.state);
    },
    getSources: debouncedGetSources,
    initialState: {
      query: initQuery
    }
  }), [inputRef]);
  return {
    autocomplete,
    autocompleteState
  };
};
export { useAlgoliaAutocomplete };